module.exports = __webpack_public_path__ + "img/wip-status.911d89bc.svg";